// About Page - About Us with founder story and achievements
import { useQuery } from 'react-query';

const fetchPage = async () => {
  const res = await fetch('/api/public/pages/about');
  return res.json();
};

export default function About() {
  const { data: page } = useQuery('page-about', fetchPage);
  
  return (
    <div>
      {/* Hero */}
      <section className="relative py-32 bg-gradient-to-br from-primary to-secondary text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-heading text-5xl font-bold mb-6">About Elite Gymnastics</h1>
          <p className="text-xl max-w-2xl mx-auto opacity-90">Nurturing young gymnasts in North London since 2007</p>
        </div>
      </section>
      
      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <h2>Our Story</h2>
            <p>
              Elite Gymnastics is a British Gymnastics and London Gymnastics Association registered club that has been 
              nurturing thousands of young gymnasts in a safe and friendly environment in the North London area since 2007.
            </p>
            
            <p>
              Our founder, <strong>Olga Berzing</strong>, was a rhythmic gymnast herself who successfully competed for the 
              Lithuanian Soviet Republic until the age of 17. Elite Gymnastics was born from her desire to offer children 
              the opportunity to find the joy and passion in this sport the same way she did.
            </p>
            
            <p>
              Olga gained various coaching qualifications in Rhythmic and Artistic gymnastics before opening, in 2007, 
              the first club in London offering both, Artistic and Rhythmic gymnastics.
            </p>
            
            <h2>Our Venues</h2>
            <p>
              Elite Gymnastics operates in a number of venues across the Enfield and Barnet Boroughs. You will find our 
              main base in Edmonton Green Leisure Centre where we cater for over 600 gymnasts alone.
            </p>
            
            <h2>Classes and Modalities</h2>
            <p>
              Our exceptional team of coaches offer safe and fun gymnastics sessions to children of all ages and abilities. 
              We run pre-school, general, artistic and rhythmic gymnastics classes at recreational and competitive levels, 
              from the age of three years old through to at least 17 years old.
            </p>
            
            <p>
              <strong>All of our coaches are BG qualified and CRB checked.</strong>
            </p>
            
            <h2>Development Opportunities</h2>
            <p>
              We are proud to say that, when the time is right, our gymnasts are given the opportunity to volunteer and 
              study to become coaches themselves. If and when gymnasts choose to follow this path, we help them become 
              fully qualified coaches whilst giving them the opportunity to develop leadership skills.
            </p>
          </div>
        </div>
      </section>
      
      {/* Founder Section */}
      <section className="py-20 bg-base-200">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12 items-center max-w-5xl mx-auto">
            <div className="flex-shrink-0">
              <div className="w-64 h-64 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white text-6xl">
                👩‍🏫
              </div>
            </div>
            <div>
              <h2 className="font-heading text-3xl font-bold mb-2">A Word From Our Founder</h2>
              <p className="text-primary font-medium mb-4">Olga Berzing - Club Founder & Head Coach</p>
              <blockquote className="text-gray-600 italic text-lg">
                "Gymnastics is my life" was the main phrase that inspired my life and goals in gymnastics, since the age of 6.
              </blockquote>
              <p className="text-gray-700 mt-4">
                Olga competed for the Lithuanian Soviet Republic until age 17, winning numerous national competitions. 
                She opened Elite Gymnastics in 2007 as the first club in London offering both Artistic and Rhythmic gymnastics. 
                She was appointed Chairman of London Rhythmic Discipline in 2009, a position she held until 2014.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Achievements */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="font-heading text-4xl font-bold text-center mb-12">Our Achievements</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {[
              { title: 'Overall 2nd Place', desc: 'Artistic Gymnastics Club - Floor and vault London Competition', year: 2014 },
              { title: '7 British Team Members', desc: 'Elite Gymnastics has produced 7 British Rhythmic team members' },
              { title: 'British & English Champions', desc: 'Multiple Champions produced between 2012-2019' },
              { title: 'Technical Committee Chairman', desc: 'London Rhythmic Gymnastics Technical Committee', year: '2009-2014' },
              { title: 'Event Organiser', desc: 'London Rhythmic Competition Programme' },
              { title: 'National BG Merit Award', desc: 'Presented to Olga Berzing', year: 2020 }
            ].map((achievement, i) => (
              <div key={i} className="card bg-base-100 shadow-lg p-6 border-l-4 border-primary">
                <h3 className="card-title text-lg font-bold">{achievement.title}</h3>
                <p className="text-gray-600 mt-2">{achievement.desc}</p>
                {achievement.year && <p className="text-primary font-medium mt-2">{achievement.year}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}